import { CheckoutConfig } from "../types";

/**
 * Options for initializing StreamPay's checkout SDK
 */
export interface Config {
  /**
   * Private API key from StreamPay's checkout dashboard
   */
  api_key: string;
  /**
   * Network where the transactions would be simulated
   */
  network: "mainnet" | "devnet";
  /**
   * Additional configuration related to the checkout session
   */
  config: CheckoutConfig;
}
